export default "__VITE_ASSET__eAPQmK1p__"